export const styles = {
  name: 'tw-font-medium tw-text-neutral-900',
  cellBlock: 'tw-flex tw-flex-col tw-gap-0.5',
  uid: 'tw-text-xs tw-text-neutral-500 tw-font-mono',
  version: 'tw-text-neutral-600 tw-text-sm',
  releaseDate: 'tw-text-xs tw-text-neutral-500',
  inactive: 'tw-text-neutral-400 tw-italic',
};
